function formatBearerToken(token: string) {
  return `Bearer ${token}`;
}

export function getAuthorizationHeader(token: string) {
  return {
    Authorization: formatBearerToken(token),
  };
}
